<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="app-container">
    <BjPage ref="BjPage"
      :label-width="'80px'"
      :query-params="queryParams" :col-span="colSpan"
      :get-action="queryApi"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :default-sort="defaultSort"
      @afterFetchOriginalData="getInvoiceTableData"
      @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @sort-change="sortChange"
      >
      <template v-slot:baseForm>
        <!-- 发票号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.searchIDs')" prop="invoiceId">
            <BjInputNumber
              v-model="queryParams.invoiceId"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('billingPage.searchID')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 总支付金额 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.totalAmount')" prop="totalAmount">
            <BjInputMoney
              v-model="queryParams.totalAmount"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('billingPage.totalAmount')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 客户 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.companySeller')" prop="companyName">
            <BjSelectLov v-model="queryParams.companyName" :option-list="clientCodeList" :placeholder="$t('billingPage.companySeller')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 年-周 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
            <el-date-picker
              id="getWeekDate"
              v-model="weekDataNow"
              :picker-options="{ firstDayOfWeek: 1 }"
              style="width: 100%"
              type="week"
              format="yyyy-WW"
              :clearable="false"
              :placeholder="$t('billingPage.yearAndWeeks')"
               @change="handleQuery"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 发票周 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.InvoiceWeek')" prop="year">
            <el-date-picker
              id="invoiceWeek"
              v-model="invoiceWeek"
              :picker-options="{ firstDayOfWeek: 1 }"
              style="width: 100%"
              type="week"
              format="yyyy-WW"
              :clearable="false"
              :placeholder="$t('billingPage.yearAndWeeks')"
               @change="handleQuery"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 状态 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Status')" prop="state">
            <BjSelectLov
              v-model="queryParams.state"
              :clearable="false"
              :option-list="BILLING_PAGE_STATUS"
              :placeholder="$t('billingPage.Status')"
              @change="handleQuery"
            />
          </el-form-item>
        </el-col>
        <!-- 类型 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BjDialogListConfig.Types')" prop="type">
            <BjSelectLov
              v-model="queryParams.type"
              :clearable="false"
              :option-list="typeList"
              :placeholder="$t('BjDialogListConfig.Types')"
              @change="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <!-- <el-button type="primary" class="main-btn" @click="onGenerate">{{ $t('billingPage.generateBilling') }}</el-button> -->
          <el-dropdown v-hasDropdownChildren @command="handleMatch">
              <el-button type="primary">
                {{ $t('billingPage.actions') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1" type="primary" @click="onGroupPDF">{{ $t('billingPage.ExportPDF') }}</el-dropdown-item>
                <el-dropdown-item :command="2" type="primary" @click="onGroupCSV">{{ $t('billingPage.ExportCSV') }}</el-dropdown-item>
                <!-- <el-dropdown-item :command="3" type="primary" @click="onGroupPMT">{{ $t('billingPage.ExportPMTCSV') }}</el-dropdown-item> -->
              </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </template>
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="!['bjTableAction', 'totalAmount', 'paidAmount'].includes(col.prop)" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'id'">
                {{ scope.row.isNew==1? 'New '+ scope.row.id : scope.row.id }}
              </span>
              <span v-else-if="col.prop === 'Period'">
                {{ scope.row.periodFrom | timeFilters }}~{{ scope.row.periodTo | timeFilters }}
              </span>
              <span v-else-if="col.prop === 'week'">
                {{ scope.row.week+"/"+scope.row.year }}
              </span>
              <el-tag v-else-if="col.prop === 'state'" :type="scope.row.state == 'PAID' ? 'success' : 'info'">
                {{ $t(BILLING_PAGE_STATUS.bjGet(scope.row.state)) }}
              </el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters }}</span>
            </template>
          </el-table-column>
          <vxe-table-column v-else-if="col.prop === 'totalAmount'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="total_amount" :title="col.label" sortable width="135px">
            <template slot-scope="scope">{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'paidAmount'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="paid_amount" :title="col.label" sortable width="135px">
            <template slot-scope="scope">{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
          </vxe-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-tooltip class="item" effect="dark" content="PDF" placement="top">
                <el-button type="text" class="edit-btn" icon="el-icon-download" style="font-size: 20px;" @click="onPDF(props.row)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="XLSX" placement="top">
                <el-button type="text" class="edit-btn" icon="el-icon-document" style="font-size: 20px;" @click="onXLSX(props.row)"></el-button>
              </el-tooltip>
              <el-button v-permission:BillingInvoiceEdit type="text" class="edit-btn" icon="el-icon-edit-outline" style="font-size: 20px;" @click="onEdit(props.row)"></el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog :title="$t('billingPage.UpdateInvoicePayment')" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form">
        <el-form-item :label="$t('billingPage.totalAmount')">:
          <BjInput v-model="form.totalAmount" disabled style="width: 300px;"></BjInput>
        </el-form-item>
        <el-form-item :label="$t('billingPage.PaidAmount')">:
          <BjInput v-model="form.paidAmount" style="margin-left: 3px;width: 300px;"></BjInput>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { billApi } from '@/api';
import { getFileUrl } from '@/api/billApi';
import { BILLING_PAGE_STATUS, PURCHASE_TYPE_NUMBER } from '@/utils/constants';
import { downloadBlob } from '@/utils/index';
import moment from 'moment';
import axios from 'axios';
import { VUE_APP_BILL_API } from '@/utils/index';

export default {
  name: 'BusinessBillingInvoices',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      BILLING_PAGE_STATUS, PURCHASE_TYPE_NUMBER,
      colSpan: 4,
      selection: true,
      dialogFormVisible: false,
      // 查询参数
      queryApi: billApi.getBillInvoicesList,
      queryParams: {
        invoiceId: null,
        totalAmount: null,
        companyName: null,
        week: null,
        invoiceWeek: null,
        state: null,
        type: null,
        // 排序字段
        sortedFields:'',
      },
      typeList:[{value:'IN',label:'IN'},{value:'CR',label:'CR'}],

      labelList: [
        { label: this.$t('billingPage.InvoicesNo'), prop: 'id', isCheck: true, disabled: false },
        { label: this.$t('billingPage.companyName'), prop: 'companyName', isCheck: true, disabled: false },
        { label: this.$t('billingPage.sellerCode'), prop: 'clientCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.totalAmount'), prop: 'totalAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.PaidAmount'), prop: 'paidAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.DateOfInvoices'), prop: 'issueDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.dueDate'), prop: 'dueDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Period'), prop: 'Period', isCheck: true, disabled: false, width: 160},
        { label: this.$t('BjDialogListConfig.Types'), prop: 'type', isCheck: true, disabled: false},
        { label: this.$t('billingPage.ApplyWeek'), prop: 'week', isCheck: true, disabled: false },
        { label: this.$t('billingPage.InvoiceWeek'), prop: 'invoiceWeek', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Status'), prop: 'state', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 120 },
      ],
      // 年-周 数据
      weekDataNow: null,
      // 发票周 数据
      invoiceWeek: null,
      // 编辑栏 数据
      form: {},
      // 下拉搜索列表
      clientCodeList: [],
      fullscreenLoading: false,
      // 金额排序
      defaultSort: [],
    };
  },
  computed: {},
  watch: {
    'weekDataNow'() {
      if (this.weekDataNow !== null) {
        this.$nextTick(() => {
          this.queryParams.year = document.querySelector('#getWeekDate').value;
        });
      }
    },
    'invoiceWeek'() {
      if (this.invoiceWeek !== null) {
        this.$nextTick(() => {
          this.queryParams.invoiceWeek = document.querySelector('#invoiceWeek').value;
        });
      }
    },
  },
  mounted() {
    this.getClientInfoList();
  },
  methods: {
    // 排序
    sortChange (column) {
      if(column.order){
        this.defaultSort = [{ field: column.field, order: column.order }];
        this.queryParams.sortedFields = `${column.field} ${String(column.order).toUpperCase()}`;
      }else{
        this.defaultSort = [];
        this.queryParams.sortedFields = ''
      }
      this.reFresh()
    },
    // 获取tableData数据
    getInvoiceTableData(data) {
      console.log(data, 'data');
      data.content.forEach(item => {
        item.periodFrom = moment(item.periodFrom).format('YYYY-MM-DD');
        item.periodTo = moment(item.periodTo).format('YYYY-MM-DD');
      });
      return data;
    },
    // 获取所有客户信息列表
    getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
      },
    // 列表右侧第一下载按钮（PDF）
    onPDF(item) {
      getFileUrl('invoDownBillInvoicePDF', {id: item.id});
      // billApi.invoDownBillInvoicePDF({id: item.id}).then(res => {
      //   downloadBlob(res, `${item.clientCode}_Week${item.week}_Year${item.year}_INV-${item.id}`);
      // });
    },
    // 列表右侧第二下载按钮（breakdown）
    onXLSX(item) {
      getFileUrl('invoDownBillbreakdown', {id: item.id});
      // billApi.invoDownBillbreakdown({id: item.id}).then(res => {
      //   downloadBlob(res, `breakdown.xlsx`);
      // });
    },
    // 打开编辑弹窗并赋值
    onEdit(item) {
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(item));
    },
    // 保存弹窗数据 并 关闭编辑弹窗
    saveAmount() {
      billApi.updateBillPayment({id: this.form.id, amount: this.form.paidAmount}).then(res => {
        this.dialogFormVisible = false;
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.reFresh();
      });
    },
    // 生成发票 按钮
    onGenerate() {
      if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
      const idList = this.selectedRows.map(e => e.id);
      billApi.geneBillGeneInvoice(idList).then(() => {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
      });
    },

    // 列表左侧  下拉操作
    handleMatch(command) {
      if (command === 1) { this.onGroupPDF(); }
      if (command === 2) { this.onGroupCSV(); }
      if (command === 3) { this.onGroupPMT(); }
    },
    // 下拉列表 批量导出PDF压缩包
    onGroupPDF() {
      if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
      const idList = this.selectedRows.map(e => e.id);
      billApi.invoExportBillpdf({ids: idList}).then(res => {
        downloadBlob(res, `PDF batch.zip`);
      });
    },
    // 下拉列表 批量导出PDF
    onGroupCSV() {
      if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
      const idList = this.selectedRows.map(e => e.id);
      this.fullscreenLoading = true;
      axios({
          method: 'post',
          url: `${VUE_APP_BILL_API()}/billing/invoice/export/batch/csv`,
          data: {ids: idList},
          responseType: 'blob',
          timeout: 1000000
      }).then((res) => {
        this.fullscreenLoading = false;
        downloadBlob(res.data, `CSV batch.zip`);
      }).catch(() => {
        this.fullscreenLoading = false;
        this.$message.error(this.$t('errorApi'));
      });
    },
    // 下拉列表 批量导出PMT CSV
    onGroupPMT() {
      if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
      const idList = this.selectedRows.map(e => e.id);
      billApi.invoExportBillPmtCsv({ids: idList}).then((res) => {
        console.log(res, 'PMT CSV batch');
        downloadBlob(res, `PMT CSV batch.csv`);
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.defaultSort = [];
      this.queryParams.sortedFields = ''
      this.queryParams.type = null;
      this.queryParams.year = null;
      this.weekDataNow = null;
      this.invoiceWeek = null;
      this.queryParams.invoiceWeek = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
